<template>
    <DropdownMenu :modal="false" @update:open="(open) => open && preloadImages(logoutImages)">
        <DropdownMenuTrigger as-child>
            <button
                type="button"
                class="flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-full ring-offset-background transition focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
                aria-label="Account menu"
            >
                <img
                    :src="userProps.profile_photo_path || userProps.profile_photo_url"
                    class="size-10 rounded-full object-cover"
                    alt=""
                />
            </button>
        </DropdownMenuTrigger>

        <DropdownMenuContent class="min-w-56" align="end" :side-offset="4">
            <DropdownMenuLabel class="flex flex-col gap-0.5">
                <span class="truncate text-sm font-semibold text-foreground">
                    {{ userProps.name }}
                </span>
                <span class="truncate text-xs font-normal text-muted-foreground">
                    {{ userProps.email }}
                </span>
            </DropdownMenuLabel>

            <DropdownMenuSeparator />

            <DropdownMenuItem class="gap-2 p-2" @click="goToProfileSettings">
                <Settings class="size-4 text-muted-foreground" />
                <span class="font-medium text-muted-foreground">Profile settings</span>
            </DropdownMenuItem>

            <DropdownMenuItem class="gap-2 p-2" @click="logout">
                <LogOut class="size-4 text-muted-foreground" />
                <span class="font-medium text-muted-foreground">Log out</span>
            </DropdownMenuItem>
        </DropdownMenuContent>
    </DropdownMenu>
</template>

<script lang="ts" setup>
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { LogOut, Settings } from 'lucide-vue-next';
import IUser from '@/types/Members/IUser';
import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import { logoutImages, preloadImages } from '@/utils/preloadAuthImages';

const globalProps = computed(() => usePage<ITopolPageProps>().props);
const userProps = computed(() => globalProps.value.user as IUser);

const goToProfileSettings = () => {
    router.visit(route('settings.profile-settings.index'));
};

const logout = () => {
    router.post(route('logout'));
};
</script>
